import { render, staticRenderFns } from "./BroadcastMessageTable.vue?vue&type=template&id=316182ce&"
import script from "./BroadcastMessageTable.vue?vue&type=script&lang=js&"
export * from "./BroadcastMessageTable.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastMessageTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports